import React from 'react';
import { StyledFormContainer, StyledHidingContainer, StyledPaperContainer, StyledSectionHeader, StyledSectionTitle, StyledSwitch } from '../../PlusWebsiteEditor.styles';
import { WebsiteConfiguration } from '../../types/websiteConfiguration';
import { InputField } from '../../../../healtheraComponents';
import { SectionHandlers, SetFieldValue } from '../../types/handlers';
import Switch from '../../../Shared/Switch';

type Props = WebsiteConfiguration['contact_us'] & SectionHandlers & { onChange: SetFieldValue<string | boolean> };

const ContactUsSection = ({
  enabled,
  contact_name,
  contact_address,
  email,
  phone_number,
  gphc_number,
  gphc_url,
  display_gphc_logo,
  contact_hours,
  pharmacy_superintendent_name,
  pharmacy_superintendent_gphc_url,
  pharmacy_superintendent_registration_number,
  onChange,
  onBlur,
  getError,
}: Props) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.name, e.target.value);

  return (
    <StyledPaperContainer>
      <StyledSectionHeader>
        <StyledSectionTitle>Contact Us</StyledSectionTitle>
        <StyledSwitch onChange={(_: any, checked: boolean) => onChange('enabled', checked, true)} label="Show section" checked={!!enabled} value={!!enabled} />
      </StyledSectionHeader>
      <StyledHidingContainer>
        <StyledFormContainer>
          <InputField onBlur={onBlur} helperText={getError('contact_name')} onChange={handleInputChange} margintop="10px" label="Contact Name" name="contact_name" value={contact_name} />
          <InputField onBlur={onBlur} helperText={getError('contact_address')} onChange={handleInputChange} margintop="10px" label="Contact Address" name="contact_address" value={contact_address} />
          <InputField onBlur={onBlur} helperText={getError('email')} onChange={handleInputChange} margintop="10px" label="Email Address" name="email" value={email} />
          <InputField onBlur={onBlur} helperText={getError('phone_number')} onChange={handleInputChange} margintop="10px" label="Phone Number" name="phone_number" value={phone_number} />
          <InputField onBlur={onBlur} helperText={getError('contact_hours')} multiline placeholder="Mon-Fri 09:00-17:00" onChange={handleInputChange} margintop="10px" label="Contact Hours" name="contact_hours" value={contact_hours} />
          <InputField
            onBlur={onBlur}
            helperText={getError('gphc_number')}
            onChange={handleInputChange}
            margintop="10px"
            label="Pharmacy GPHC Registration Number"
            name="gphc_number"
            value={gphc_number}
          />
          <InputField onBlur={onBlur} helperText={getError('gphc_url')} onChange={handleInputChange} margintop="10px" label="Pharmacy GPHC URL" name="gphc_url" value={gphc_url} />
          <Switch onChange={(_: any, checked: boolean) => onChange('display_gphc_logo', checked, true)} label="Display GPHC Logo" checked={!!display_gphc_logo} value={!!display_gphc_logo} disabled={false} reverseOrder={false} />
          <InputField
            onBlur={onBlur}
            helperText={getError('pharmacy_superintendent_name')}
            onChange={handleInputChange}
            margintop="10px"
            label="Pharmacy Superintendent Name"
            name="pharmacy_superintendent_name"
            value={pharmacy_superintendent_name}
          />
          <InputField
            onBlur={onBlur}
            helperText={getError('pharmacy_superintendent_registration_number')}
            onChange={handleInputChange}
            margintop="10px"
            label="Pharmacy Superintendent registration number"
            name="pharmacy_superintendent_registration_number"
            value={pharmacy_superintendent_registration_number}
          />
          <InputField
            onBlur={onBlur}
            helperText={getError('pharmacy_superintendent_gphc_url')}
            onChange={handleInputChange}
            margintop="10px"
            label="Pharmacy Superintendent GPHC URL"
            name="pharmacy_superintendent_gphc_url"
            value={pharmacy_superintendent_gphc_url}
          />
        </StyledFormContainer>
      </StyledHidingContainer>
    </StyledPaperContainer>
  );
};

export default ContactUsSection;
